//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import myContent from './content.vue'
// import moreContent from '@/components/more-content/index.vue'
// import search from '@/js/common/search/index.vue'
export default {
  components: { myContent },
  data() {
    return {
      //swiper轮播图
      indicatorDots: false, //是否显示面板指示点
      circular: true, //是否采用衔接滑动
      autoplay: true, //是否自动切换
      interval: 3000, //自动切换时间间隔
      duration: 500, //滑动动画时长
      imgList: [], //轮播图数组
      current: 1, //当前所在滑块
      currentLength: 1, //图片总数
      id: '',
      url: {
        queryDataById: '/weChat/cms/viewspot/queryById',
        queryList: '/weChat/cms/viewspot/queryPage'
      },
      isPlayAudio: false,
      innerAudioContext: '',
      showSecond: true,
      score: 4,
      spotList: [],
      tagList:[],
      detail: {
        name: '', // 景点名称
        coverImagesUrl: '', // 景点封面图
        viewspotAudio: '', // 景区音频地址
        introduction: '', // 景区介绍,
        scenicspotName: '', // 所属景区名称,
        photoImagesUrls: '',
        secnicspotTag: '' // 缺字段
      }
    }
  },
  computed: {
    videoIcon() {
      return this.isPlayAudio ? require('@/static/scenicTutorials/detailplay.png') : require('@/static/scenicTutorials/detailvoice.png')
    },
    showList() {
      return this.spotList.filter(t => {
        return t.id !== this.id
      }).slice(0, 4)
    }
  },
  onLoad(event) {
    // console.log(this.id)
    this.id = event.id || ''
    this.queryData()
    this.innerAudioContext = uni.createInnerAudioContext();
  },
  beforeDestroy() {
  },
  methods: {
    handleClick() {
      uni.navigateTo({
        url: '/pages/scenicTutorials/detail?id=' + this.detail.scenicspotId
      })
    },
    //顶部轮播图当前图片页数
    changeImg(event) {
      this.current = event.detail.current + 1
    },
    playAudio() {
      // var myAuto = document.getElementById('myAudio')
      // // myAuto.src = this.scenicspotInfo.scenicspotAudioUrl
      // if (this.isPlayAudio) {
      //   myAuto.pause()
      // } else {
      //   myAuto.play()
      // }
      // this.isPlayAudio = !this.isPlayAudio
      this.innerAudioContext.onPause(() => {
        console.log('暂停');
      });
      this.innerAudioContext.onPlay(() => {
        console.log('开始播放');
      });
      this.innerAudioContext.onError((res) => {
        console.log(res.errMsg);
        console.log(res.errCode);
      });
      if (!this.innerAudioContext.paused) {
        this.innerAudioContext.pause();
      } else {
        this.innerAudioContext.play();
      }
      this.isPlayAudio = !this.isPlayAudio
    },
    async queryData() {
      let data = await this.$ajax({
        url: this.url.queryDataById,
        method: 'post',
        data: {
          id: this.id
        }
      })
      this.detail = data.data
      this.tagList = this.detail.tagList? this.detail.tagList :[]
      this.imgList = this.detail.photoImagesUrls.split(',')
      this.currentLength = this.imgList.length || 0
      this.innerAudioContext.src = this.$getImg(this.detail.viewspotAudio);
      // this.queryOtherData()
    },
    async queryOtherData() { // 其他景点
      let data = await this.$ajax({
        url: this.url.queryList,
        method: 'post',
        data: {
          scenicspotId: this.detail.scenicspotId,
          currentPage: 1,
          pageSize: 10
        }
      })
      this.spotList = data.data
    }
  }
}
